<template>
  <div class="fluid" id="overtimeMultiplierSetting">
    <div>
      <div class="overtime-multiplier-list-dev">
        <v-card
          elevation="1"
          class="px-3 py-2"
          style="width:800px; border:1px solid rgba(0, 0, 0, 0.404);"
        >
          <v-row>
            <v-col
              cols="12"
              class="d-flex"
              style="position:relative;padding:0 20px;text-align:center;margin-top:20px;"
            >
              <h4 class="indigo--text" style="font-weight:bold;margin:auto;">
                OVERTIME MULTIPLIER SETTING
                <v-tooltip bottom color="grey">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      x-small
                      text
                      icon
                      color="grey darken-2"
                      @click="getDataFromApi"
                    >
                      <v-icon small>mdi-refresh</v-icon>
                    </v-btn>
                  </template>
                  <span>refresh page</span>
                </v-tooltip>
              </h4>
            </v-col>
            <v-col cols="12">
              <div>
                <v-toolbar
                  class="overtime-multiplier-list-toolbar-1"
                  flat
                  style="height: 60px; border-radius: 10px 10px 0 0; padding-top:15px;"
                >
                  <div class="d-flex align-content-start">
                    <div
                      style="margin-right:15px; height:45px;"
                      class="d-flex justify-center align-center"
                    >
                      <v-btn
                        style="
                      font-size: 12px;
                      "
                        @click="addOvertimeMultiplier"
                        elevation="2"
                        tilerounded="5px"
                        color="primary"
                        class="white--text"
                        small
                      >
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon v-bind="attrs" v-on="on" small class="">
                              mdi-plus
                            </v-icon>
                          </template>
                          <span>Add Setting</span>
                        </v-tooltip>
                      </v-btn>
                    </div>
                    <div style="width: 210px;">
                      <v-autocomplete
                        v-model="paramAPI.type"
                        label="Type"
                        item-text="name"
                        item-value="id"
                        return-id
                        dense
                        outlined
                        clearable
                        :items="dropdown.type"
                      ></v-autocomplete>
                    </div>
                  </div>
                </v-toolbar>
              </div>
            </v-col>

            <v-col cols="12" class="d-flex justify-center align-center">
              <v-data-table
                mobile-breakpoint="0"
                fixed-header
                height="50vh"
                :headers="headers"
                style="cursor: pointer; width:90%;"
                :items="result"
                :loading="loading"
                @click:row="rowClick"
                item-key="id"
                :options.sync="options"
                :footer-props="{
                  showFirstLastPage: true,
                  showCurrentPage: true,
                  itemsPerPageOptions: [1, 3, 5, 10, 15, 100]
                }"
                :server-items-length="totalData"
                @update:page="updatePage"
                @update:items-per-page="updateItemPerPage"
              >
                <!-- <template v-slot:[`item.no`]="{ index }">
                    <div
                      style="font-size:14px; padding: 0; display: flex; flex-direction: row;"
                    >
                      {{ index + 1 + paramAPI.offset * paramAPI.limit }}
                    </div>
                  </template> -->
                <template v-slot:[`item.type`]="{ item }">
                  <div
                    style="padding: 0; display:flex; justify-content:center; align-items:center;"
                  >
                    {{ multiplierType(item.type) }}
                  </div>
                </template>
                <template v-slot:[`item.start_hour`]="{ item }">
                  <div
                    style="padding: 0; display:flex; justify-content:center; align-items:center;"
                  >
                    {{ item.start_hour }}
                    <span style="font-size:12px; margin-left:5px;">
                      hour
                    </span>
                  </div>
                </template>
                <template v-slot:[`item.end_hour`]="{ item }">
                  <div
                    style="padding: 0; display:flex; justify-content:center; align-items:center;"
                  >
                    {{ item.end_hour }}
                    <span style="font-size:12px; margin-left:5px;">
                      hour
                    </span>
                  </div>
                </template>
                <template v-slot:[`item.multiply`]="{ item }">
                  <div
                    style="padding: 0; display:flex; justify-content:center; align-items:center;"
                  >
                    {{ item.multiply }}
                  </div>
                </template>
                <template v-slot:[`item.divide`]>
                  <div
                    style="padding: 0; display:flex; justify-content:center; align-items:center;"
                  >
                    to
                  </div>
                </template>
                <template v-slot:[`item.equal`]>
                  <div
                    style="padding: 0; display:flex; justify-content:center; align-items:center;"
                  >
                    =
                  </div>
                </template>
                <template v-slot:[`item.createdAt`]="{ item }">
                  <div
                    style="font-size:12px; padding: 0; display: flex; flex-direction: row"
                  >
                    {{ convertDate(item.createdAt) }}
                  </div>
                </template>
                <template v-slot:[`item.updatedAt`]="{ item }">
                  <div
                    style="font-size:12px; padding: 0; display: flex; flex-direction: row"
                  >
                    {{ convertDate(item.updatedAt) }}
                  </div>
                </template>
                <template v-slot:[`item.action`]="{ item }">
                  <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }"
                      ><v-icon
                        v-bind="attrs"
                        v-on="on"
                        @click.stop="rowClick(item)"
                        small
                        color="primary"
                        class="mr-2"
                      >
                        mdi-pencil
                      </v-icon>
                    </template>
                    <span>Edit</span>
                  </v-tooltip>
                  <v-tooltip right>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        v-bind="attrs"
                        v-on="on"
                        small
                        color="error"
                        @click.stop="deleteItem(item)"
                      >
                        mdi-delete
                      </v-icon>
                    </template>
                    <span>Delete</span>
                  </v-tooltip>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card>
      </div>
    </div>
    <v-dialog v-model="settingDialog" persistent max-width="500px">
      <v-card v-if="form !== null">
        <v-card-title>
          <span class="text-h5">Add/Edit Group</span>
        </v-card-title>
        <v-form ref="entryForm2" @submit.prevent="saveSetting">
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="6" class="d-flex flex-column">
                  <p
                    class="text-left"
                    style="
                        margin: 0;
                        font-size: 12px;
                        font-weight: bold;
                        color: rgba(0, 0, 0, 0.5);
                      "
                  >
                    Type
                  </p>
                  <div style="height:40px;">
                    <v-autocomplete
                      v-model="form.type"
                      :items="dropdown.type"
                      :rules="rules.typeRules"
                      item-text="name"
                      item-value="id"
                      return-id
                      dense
                      outlined
                      clearable
                    ></v-autocomplete>
                  </div>
                </v-col>
                <v-col cols="6" class="d-flex flex-column"></v-col>
                <v-col cols="4" class="d-flex flex-column">
                  <p
                    class="text-left"
                    style="
                        margin: 0;
                        font-size: 12px;
                        font-weight: bold;
                        color: rgba(0, 0, 0, 0.5);
                      "
                  >
                    Start
                  </p>
                  <div class="d-flex justify-center align-center">
                    <v-text-field
                      v-model="form.start_hour"
                      :rules="rules.startRules"
                      type="number"
                      min="0"
                      dense
                    ></v-text-field>
                    <div
                      class="d-flex justify-center align-center"
                      style="position:relative; top:-5px;"
                    >
                      <p style="margin:0 0 0 5px; font-size:12px;">hour</p>
                      <p style="margin:0 0 0 20px; font-weight:bolder;">
                        to
                      </p>
                    </div>
                  </div>
                </v-col>
                <v-col cols="4" class="d-flex flex-column">
                  <p
                    class="text-left"
                    style="
                        margin: 0;
                        font-size: 12px;
                        font-weight: bold;
                        color: rgba(0, 0, 0, 0.5);
                      "
                  >
                    End
                  </p>

                  <div class="d-flex justify-center align-center">
                    <v-text-field
                      v-model="form.end_hour"
                      :rules="rules.endRules"
                      type="number"
                      min="0"
                      dense
                    ></v-text-field>
                    <div
                      class="d-flex justify-center align-center"
                      style="position:relative; top:-5px;"
                    >
                      <p style="margin:0 0 0 5px; font-size:12px;">hour</p>
                      <p style="margin:0 0 0 20px; font-weight:bolder;">
                        =
                      </p>
                    </div>
                  </div>
                </v-col>

                <v-col cols="4" class="d-flex flex-column">
                  <p
                    class="text-left"
                    style="
                        margin: 0;
                        font-size: 12px;
                        font-weight: bold;
                        color: rgba(0, 0, 0, 0.5);
                      "
                  >
                    Multiply
                  </p>
                  <div class="d-flex justify-center align-center">
                    <v-text-field
                      v-model="form.multiply"
                      :rules="rules.multiplyRules"
                      type="double"
                      min="0"
                      dense
                    ></v-text-field>
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="closeSettingDialog">
              Close
            </v-btn>
            <v-btn color="blue darken-1" text type="submit">
              Save
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from 'axios'
import { mapGetters /*  mapMutations mapActions */ } from 'vuex'
import buildType from '../../../../services/buildType'
export default {
  name: 'msovertimemultiplier',
  data: () => ({
    editDialog: false,
    settingDialog: false,
    hrsApi: buildType.apiURL('hrs'),
    eSanqua: buildType.apiURL('esanqua'),
    build: process.env.VUE_APP_BUILD_TYPE,
    paramAPI: {
      page: 1,
      keyword: '',
      offset: 0,
      limit: 10,
      itemsPerPage: 10,
      sortBy: 'id',
      sortType: 'ASC',
      company_id: null,
      type: null
    },
    totalData: 0,
    form: null,
    detail: null,
    isEdit: false,

    options: {},
    actionValue: 0,
    headers: [
      //   {
      //     text: 'No',
      //     value: 'no',
      //     align: 'left',
      //     sortable: false
      //   },
      //   {
      //     text: '',
      //     value: 'space',
      //     align: 'left',
      //     sortable: false,
      //     width: '50px'
      //   },
      {
        text: 'Type',
        value: 'type',
        align: 'center',
        sortable: false,
        width: '160px'
      },
      {
        text: 'Start',
        value: 'start_hour',
        align: 'center',
        sortable: false,
        width: '70px'
      },
      {
        text: '',
        value: 'divide',
        align: 'center',
        sortable: false,
        width: '10px'
      },
      {
        text: 'End',
        value: 'end_hour',
        align: 'center',
        sortable: false,
        width: '70px'
      },
      {
        text: '',
        value: 'equal',
        align: 'center',
        sortable: false,
        width: '10px'
      },
      {
        text: 'Multiply',
        value: 'multiply',
        align: 'center',
        sortable: false,
        width: '120px'
      },
      //   {
      //     text: 'Created at',
      //     value: 'createdAt',
      //     align: 'left',
      //     sortable: false
      //   },
      //   {
      //     text: 'Updated at',
      //     value: 'updatedAt',
      //     align: 'left',
      //     sortable: false
      //   },
      {
        text: 'Actions',
        value: 'action',
        align: 'center',
        sortable: false,
        width: '100px'
      }
    ],
    result: [],
    loading: false,
    rules: {
      startRules: [],
      endRules: [],
      multiplyRules: [],
      typeRules: []
    },
    dropdown: {
      type: [
        {
          id: 1,
          name: 'Working days'
        },
        {
          id: 2,
          name: 'Day off (5 days)'
        },
        {
          id: 3,
          name: 'Day off (6 days)'
        }
      ]
    }
  }),

  async mounted() {
    this.paramAPI.company_id = Number(
      this.getUserProfile.employee.company.plant_id
    )
    this.paramAPI.department_id = this.getUserProfile.employee.department_id
    await this.getDataFromApi()
  },
  computed: {
    // , 'getDropdownPlant'
    ...mapGetters(['getUserProfile'])
  },
  watch: {
    'paramAPI.type'(v) {
      this.getDataFromApi()
    }
  },
  methods: {
    // ...mapActions(['dropdownPlant']),
    showMsgDialog(pModalType, pStatusMsg, pBtnCancel) {
      return new Promise(resolve => {
        this.$swal
          .fire({
            position: 'center',
            icon: pModalType,
            html: '<strong style="font-size:18px;">' + pStatusMsg + '</strong>',
            showConfirmButton: true,
            showCancelButton: pBtnCancel,
            cancelButtonText: 'No'
          })
          .then(r => {
            resolve(r)
          })
      })
    },

    async getDataFromApi() {
      this.loading = true
      await this.initDataTable().then(data => {
        console.log(data)
        setTimeout(() => {
          this.result = data.data
          this.totalData = data.total_record
          this.loading = false
        }, 1000)
      })
    },
    async initDataTable() {
      let url = `${
        this.hrsApi
      }master/universal/overtimemultipliersetting/list?keyword=${
        this.paramAPI.keyword
      }&offset=${this.paramAPI.offset * this.paramAPI.limit}&limit=${
        this.paramAPI.limit
      }&order_by=${this.paramAPI.sortBy}&order_type=${this.paramAPI.sortType}`
      if (this.paramAPI.type !== null) {
        url = url + `&type=${this.paramAPI.type}`
      }
      console.log('url >>>>', url)
      return await new Promise(resolve => {
        axios
          .get(url)
          .then(res => {
            console.log(res)
            resolve(res.data)
          })
          .catch(err => {
            console.log(err)
          })
      })
    },
    enableEdit() {
      var oldForm = this.form
      this.isEdit = !this.isEdit
      if (!this.isEdit) {
        this.form = oldForm
        if (this.form.act === 'add') {
          this.closeDialog()
        }
      }
    },

    rowClick(pItem) {
      console.log(pItem)
      this.form = {
        act: 'update',
        id: pItem.id,
        start_hour: pItem.start_hour,
        end_hour: pItem.end_hour,
        multiply: pItem.multiply,
        type: pItem.type
      }
      setTimeout(() => {
        this.settingDialog = !this.settingDialog
      }, 300)
    },
    closeDialog() {
      this.form = null
      this.detail = null
      this.isEdit = false
      setTimeout(() => {
        this.editDialog = false
      }, 300)
    },
    addOvertimeMultiplier() {
      this.form = {
        act: 'add',
        start_hour: 0,
        end_hour: 0,
        multiply: 0,
        type: null
      }
      setTimeout(() => {
        this.settingDialog = !this.settingDialog
      }, 300)
    },
    saveSetting() {
      this.rules.startRules = [v => !!v || 'start is required']
      this.rules.endRules = [v => !!v || 'end is required']
      this.rules.typeRules = [v => !!v || 'type value is required']
      this.rules.multiplyRules = [v => !!v || 'multiply value is required']
      const self = this
      setTimeout(function() {
        if (self.$refs.entryForm2.validate()) {
          // self.createNewForm()
          const form = {
            act: self.form.act,
            name: '-',
            start_hour: self.form.start_hour,
            end_hour: self.form.end_hour,
            multiply: self.form.multiply,
            type: self.form.type
          }
          if (form.act === 'update') {
            Object.assign(form, { id: self.form.id })
          }
          self.submitSetting(form)
        }
      })
    },
    async submitSetting(form) {
      await axios
        .post(
          `${this.hrsApi}master/universal/overtimemultipliersetting/save`,
          form
        )
        .then(async res => {
          console.log(res.data)
          if (res.data.status_code !== '-99') {
            this.showMsgDialog('success', res.data.status_msg, false)
            this.getDataFromApi()
            this.closeSettingDialog()
          } else {
            if (res.data.status_msg === 'Parameter value has problem') {
              this.showMsgDialog(
                'warning',
                'Invalid input, Parameter value has problem',
                false
              )
            } else {
              this.showMsgDialog('warning', res.data.status_msg, false)
            }
          }
        })
        .catch(err => {
          console.log(err)
          this.showMsgDialog(
            'error',
            err
              ? 'Something went wrong, Please contact an admin!'
              : 'Something went wrong, Please contact an admin!',
            false
          )
        })
    },
    async deleteItem(pItem) {
      this.showMsgDialog(
        'question',
        'Are you sure, This data will be deleted permanently',
        true
      ).then(async res => {
        if (res.isConfirmed) {
          await axios
            .delete(
              `${this.hrsApi}master/universal/overtimemultipliersetting/delete/${pItem.id}`
            )
            .then(async res => {
              if (res.data.status_code !== '-99') {
                this.showMsgDialog('success', res.data.status_msg, false)
                this.getDataFromApi()
              } else {
                this.showMsgDialog('warning', res.data.status_msg, false)
              }
            })
            .catch(err => {
              console.log(err)
              this.showMsgDialog(
                'error',
                err
                  ? 'Something went wrong, Please contact an admin!'
                  : 'Something went wrong, Please contact an admin!',
                false
              )
            })
        }
      })
    },
    closeSettingDialog() {
      this.form = null
      setTimeout(() => {
        this.settingDialog = false
      }, 300)
    },
    async updatePage(p) {
      this.paramAPI.page = p
      this.paramAPI.offset = p - 1
      await this.getDataFromApi()
    },
    async updateItemPerPage(p) {
      this.paramAPI.limit = p
      this.paramAPI.offset = 0
      await this.getDataFromApi()
    },
    convertDate(raw) {
      if (raw !== null) {
        const date = new Date(raw)
        const local = date.toLocaleString('id')
        return local
      } else {
        return '-'
      }
    },
    multiplierType(val) {
      let type = ''
      if (val !== null) {
        switch (val) {
          case 1:
            type = 'Working days'
            break
          case 2:
            type = 'Day off (5 day)'
            break
          case 3:
            type = 'Day off (6 day)'
            break

          default:
            break
        }
      }
      return type
    }
  }
}
</script>
<style lang="scss">
#overtimeMultiplierSetting {
  position: relative;
  .overtime-multiplier-list-dev {
    padding: 15px;
    min-height: 50vh;
    display: flex;
    justify-content: center;
    align-items: center;

    .overtime-multiplier-list-toolbar-1 {
      .overtime-multiplier-list-toolbar-1 {
        width: 60%;
        display: flex;
        flex-direction: row;
        margin-left: auto;
      }
    }
    .activity-list-toolbar-2 {
      display: none;
    }
  }
}

@media (max-width: 768px) {
  #overtimeMultiplierSetting {
    .overtime-multiplier-list-dev {
      .overtime-multiplier-list-toolbar-1 {
        .overtime-multiplier-list-toolbar-1 {
          display: none;
        }
      }
      .activity-list-toolbar-2 {
        display: block;
      }
    }
  }
}
</style>
